(() => {
  const root = document.querySelector('[data-bloomly-product]');
  if (!root) return;
  const form = root.querySelector('.bl-pdp-form');
  const price = root.querySelector('[data-pdp-price]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const mainImage = root.querySelector('[data-gallery-main]');
  const mainSource = root.querySelector('[data-gallery-source]');
  const subscriptionCard = root.querySelector('[data-subscription-card]');
  const sellingPlanInput = root.querySelector('[name="selling_plan"]');
  const sellingPlanData = root.querySelector('[data-selling-plans]');
  const sellingPlans = sellingPlanData ? JSON.parse(sellingPlanData.textContent) : {};

  const item = () => ({
    item_id: root.dataset.itemId || '', item_name: root.dataset.itemName || '', item_brand: 'BLOOMLY',
    item_variant: root.dataset.itemVariant || '', price: Number(root.dataset.price || 0),
    quantity: Number(form?.querySelector('[name="quantity"]')?.value || 1)
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'view_item', ecommerce: { currency: 'GBP', value: item().price, items: [item()] } });

  const syncActiveThumb = (mediaId, src) => {
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    if (!thumbs.length) return;
    const match = thumbs.find((thumb) => (mediaId && thumb.dataset.mediaId === mediaId) || thumb.dataset.src === src);
    thumbs.forEach((thumb) => thumb.setAttribute('aria-current', thumb === match ? 'true' : 'false'));
    if (match) match.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  root.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', 'false'));
    button.setAttribute('aria-current', 'true');
    mainImage.src = button.dataset.src;
    mainImage.srcset = button.dataset.srcset || '';
    mainImage.alt = button.dataset.alt || '';
    if (mainSource) mainSource.srcset = button.dataset.srcset || button.dataset.src;
  }));

  const syncPurchaseType = () => {
    const subscription = root.querySelector('[name="purchase_type"]:checked')?.value === 'subscription';
    if (sellingPlanInput) {
      sellingPlanInput.disabled = !subscription;
      sellingPlanInput.value = subscription ? (sellingPlans[root.dataset.variantId]?.id || '') : '';
    }
  };
  root.querySelectorAll('[name="purchase_type"]').forEach((radio) => radio.addEventListener('change', syncPurchaseType));

  root.querySelectorAll('[data-pack-input]').forEach((radio) => radio.addEventListener('change', () => {
    const label = radio.closest('[data-pack]');
    root.dataset.variantId = radio.value;
    root.dataset.itemVariant = label.dataset.variantTitle;
    root.dataset.price = label.dataset.priceNumber;
    root.dataset.itemId = label.dataset.sku || radio.value;
    if (price) price.textContent = label.dataset.price;
    if (stickyPrice) stickyPrice.textContent = label.dataset.price;
    const plan = sellingPlans[radio.value];
    if (subscriptionCard) subscriptionCard.hidden = !plan;
    if (!plan && root.querySelector('[name="purchase_type"][value="subscription"]')?.checked) {
      root.querySelector('[name="purchase_type"][value="one_time"]').checked = true;
    }
    syncPurchaseType();
    if (label.dataset.image && mainImage) {
      const srcset = label.dataset.imageSrcset || label.dataset.image;
      mainImage.src = label.dataset.image;
      mainImage.srcset = srcset;
      mainImage.alt = label.dataset.imageAlt || '';
      // The <source> in the <picture> wins over the <img>, so it has to move too.
      if (mainSource) mainSource.srcset = srcset;
      syncActiveThumb(label.dataset.mediaId, label.dataset.image);
    }
    history.replaceState({}, '', `${location.pathname}?variant=${radio.value}`);
  }));

  root.querySelectorAll('[data-qty]').forEach((button) => button.addEventListener('click', () => {
    const input = form.querySelector('[name="quantity"]');
    const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.qty));
    input.value = next;
  }));

  // --- Free gifts on the bigger bundles -------------------------------------------------------
  // The theme never prices anything at zero: it adds the gift at its real price and tags the line
  // (_gift / _gift_for). The automatic discount that makes it free lives in the Shopify admin.
  const giftVariantsFor = (label) => (label?.dataset.giftVariants || '')
    .split(',').map((id) => id.trim()).filter(Boolean);

  const cartJson = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then((response) => (response.ok ? response.json() : Promise.reject(response)));

  // Gifts that no longer have their bundle in the cart are taken back out. This runs whenever a
  // product page loads, so removing the bundle from the cart and carrying on browsing clears them.
  const sweepOrphanedGifts = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const present = new Set(cart.items.map((item) => String(item.variant_id)));
      const updates = {};
      cart.items.forEach((item) => {
        const giftFor = item.properties?._gift_for;
        if (item.properties?._gift && giftFor && !present.has(String(giftFor))) {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length) await cartJson('/cart/update.js', { updates });
    } catch (_) { /* a cart that cannot be read is left exactly as it is */ }
  };
  sweepOrphanedGifts();

  // The gifts are added right after the bundle itself lands in the cart. The submit is left to the
  // theme's own product form, so every existing behaviour — the error message, the cart drawer,
  // the loading state — is untouched; this only appends lines afterwards.
  const addGiftsFor = async (variantId, giftIds) => {
    if (!giftIds.length) return;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const inCart = cart.items.some((item) => String(item.variant_id) === String(variantId));
      if (!inCart) return;
      const already = new Set(cart.items
        .filter((item) => item.properties?._gift && String(item.properties._gift_for) === String(variantId))
        .map((item) => String(item.variant_id)));
      const items = giftIds.filter((id) => !already.has(String(id))).map((id) => ({
        id: Number(id),
        quantity: 1,
        properties: { _gift: 'true', _gift_for: String(variantId) }
      }));
      if (!items.length) return;
      await cartJson('/cart/add.js', { items });
      document.dispatchEvent(new CustomEvent('bloomly:gifts-added', { detail: { variantId, items } }));
    } catch (_) { /* the bundle is in the cart either way; a failed gift add never blocks checkout */ }
  };

  if (form) {
    form.addEventListener('submit', () => {
      const label = root.querySelector('[data-pack]:has(input:checked)') || root.querySelector('[data-pack]');
      const giftIds = giftVariantsFor(label);
      const variantId = form.querySelector('[name="id"]:checked')?.value
        || form.querySelector('[name="id"]')?.value;
      if (!giftIds.length || !variantId) return;
      // The form posts through the theme's product-form component; the bundle is in the cart a
      // moment later. Poll briefly for it rather than guessing a fixed delay.
      let attempts = 0;
      const tryAdd = async () => {
        attempts += 1;
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
        const landed = cart?.items.some((item) => String(item.variant_id) === String(variantId));
        if (landed) return addGiftsFor(variantId, giftIds);
        if (attempts < 12) setTimeout(tryAdd, 350);
      };
      setTimeout(tryAdd, 350);
    });
  }

  const mainButton = root.querySelector('[data-main-atc]');
  const sticky = document.querySelector('[data-pdp-sticky]');
  if (mainButton && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const hasPassedAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      sticky.classList.toggle('is-visible', hasPassedAboveViewport);
    }, { threshold: 0 }).observe(mainButton);
    sticky.querySelector('button')?.addEventListener('click', () => mainButton.click());
  }

  // Tabs scroll to their section instead of jumping, and the URL keeps the anchor so the page
  // can be linked to. The theme sets no global scroll-behavior, so it is done here.
  document.querySelectorAll('.bl-pdp-nav a').forEach((link) => link.addEventListener('click', (event) => {
    const section = document.querySelector(link.hash);
    if (!section) return;
    event.preventDefault();
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    history.replaceState({}, '', link.hash);
  }));

  const navLinks = [...document.querySelectorAll('.bl-pdp-nav a')];
  const sections = navLinks.map((link) => document.querySelector(link.hash)).filter(Boolean);
  if (sections.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) navLinks.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
    }), { rootMargin: '-35% 0px -55%' });
    sections.forEach((section) => observer.observe(section));
  }

  // Read more. The control only appears when the description is genuinely longer than the cap,
  // so a short one is never followed by a button that does nothing.
  const clamp = root.querySelector('[data-clamp]');
  const clampToggle = root.querySelector('[data-clamp-toggle]');
  if (clamp && clampToggle) {
    const capped = clamp.scrollHeight - clamp.clientHeight > 24;
    clampToggle.hidden = !capped;
    if (!capped) clamp.classList.add('is-open');
    clampToggle.addEventListener('click', () => {
      const open = clamp.classList.toggle('is-open');
      clampToggle.setAttribute('aria-expanded', String(open));
      clampToggle.textContent = open ? 'Read less' : 'Read more';
      if (!open) clamp.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }

  // Story strip. The arrows and dots only exist while the track actually overflows, so a
  // product with few images gets a plain row instead of dead controls.
  const story = root.querySelector('[data-story]');
  const storyTrack = story?.querySelector('[data-story-track]');
  if (story && storyTrack && storyTrack.children.length) {
    const arrows = story.querySelector('[data-story-arrows]');
    const dotsBox = story.querySelector('[data-story-dots]');
    const items = [...storyTrack.children];
    const steppers = [...story.querySelectorAll('[data-story-step]')];

    if (dotsBox) items.forEach(() => dotsBox.append(Object.assign(document.createElement('span'), { className: 'bl-story__dot' })));

    const pitch = () => {
      const first = items[0].getBoundingClientRect();
      const second = items[1]?.getBoundingClientRect();
      return Math.max(1, second ? second.left - first.left : first.width);
    };

    const sync = () => {
      const max = storyTrack.scrollWidth - storyTrack.clientWidth;
      const overflows = max > 12;
      if (arrows) arrows.hidden = !overflows;
      if (dotsBox) dotsBox.hidden = !overflows;
      if (!overflows) return;
      const index = Math.min(items.length - 1, Math.round(storyTrack.scrollLeft / pitch()));
      if (dotsBox) [...dotsBox.children].forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
      steppers.forEach((button) => {
        button.disabled = Number(button.dataset.storyStep) < 0 ? storyTrack.scrollLeft <= 2 : storyTrack.scrollLeft >= max - 2;
      });
    };

    steppers.forEach((button) => button.addEventListener('click', () => {
      storyTrack.scrollBy({ left: Number(button.dataset.storyStep) * storyTrack.clientWidth, behavior: 'smooth' });
    }));

    let scrollTicking = false;
    storyTrack.addEventListener('scroll', () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => { scrollTicking = false; sync(); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(storyTrack);
    sync();
  }
})();
